module.exports = [{"type":"title","text":"2024-04-25"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續修改接口：查詢合約基礎信息支持按單個合約查詢。"},{"type":"html","text":"永續修改接口：allFillOrders接口，當沒有提供symbol字段時，將返回所有幣對歷史成交信息。"},{"type":"html","text":"永續修改：查詢持倉接口新增返回保證金字段。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-04-25.json
// module id = 87c6
// module chunks = 3